import * as THREE from 'three'
import type { GLTF } from 'three/examples/jsm/loaders/GLTFLoader.js'

import { AssetManager } from '@js/loaders'
import { BaseModel, AnimatedObject } from '../core'


export class Room extends BaseModel {

  public camera!: THREE.PerspectiveCamera
  private markers: Map<string, THREE.Object3D> = new Map()

  protected getModelUrl(): string {
    const url = AssetManager.getInstance().get('models', 'room.glb')
    if (!url) throw new Error('room.glb not found')
    return url
  }

  protected onLoaded(gltf: GLTF): void {

    gltf.scene.traverse(obj => {

      // select camera
      if ((obj as any).isCamera) {
        this.camera = obj as THREE.PerspectiveCamera
      }

      if (obj.name) {
        this.markers.set(obj.name.toUpperCase(), obj)
      }
    })
  }

  update(delta: number): void {
    const animatedCamera = this.camera as AnimatedObject
    animatedCamera.mixer?.update(delta)
  }


  getMarker(name: string): THREE.Object3D | undefined {
    return this.markers.get(name.toUpperCase())
  }

  playCameraAnimation(label: string): void {
    if (!this.gltf || !this.camera) return

    const animated = this.camera as AnimatedObject
    animated.actions?.[label]?.play()
  }
}


